<shell-layout class="pt-12">
  <img class="error__img" src="assets/img/errors/error__info-not-loaded.svg" alt="" />

  <ui-text class="error__title" color="blue-500" size="h4" weight="semibold"> ¡Oh, no! </ui-text>

  <ui-text class="error__description" color="blue-300">
    No hemos podido verificar las respuestas, por favor vuelve a intentarlo.
  </ui-text>

  <ui-button
    (clicked)="closeModal()"
    class="error__action"
    type="primary"
    label="Reintentar"
  ></ui-button>
</shell-layout>
